// material-ui
import { Box, FormControl } from '@mui/material';
import ListaTransportista from '../../../../pages/App_Aplicacion/_Componenet/_M.Transportista';
// import AuthContext from '../../../../contexts/JWTContext';
// import { useContext } from 'react';

// assets
// ==============================|| HEADER CONTENT - SEARCH ||============================== //
const Search = () => {
  // let context = useContext(AuthContext);
  return (
    <>
      <Box sx={{ width: '100%', ml: { xs: 0, md: 2 } }}>
      <FormControl sx={{ width: { xs: '100%', md: '96%' } }}>
      
       {sessionStorage.getItem('rol') === 'M' || sessionStorage.getItem('rol') === "A" || sessionStorage.getItem('rol') === "S" ?  <ListaTransportista />:null }
      </FormControl>
    </Box>
    </>
  
  );
};

export default Search;
